import {
  ChangeDetectorRef,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Subscription } from 'rxjs';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { MapService } from 'src/app/services/map.service';
import { CreateGameInfoModalComponent } from '../create-game-info-modal/create-game-info-modal.component';
import { CreateGameInvitationModalComponent } from '../create-game-invitation-modal/create-game-invitation-modal.component';
import { InfoBarMapViewService } from 'src/app/services/info-bar-map-view.service';
import { layerlist } from 'src/app/constant/maplayers';
import { CityMapService } from 'src/app/services/city-map.service';
import { DataService } from 'src/app/services/data.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { WORLD_TUMBLER_URL } from 'src/app/constant/constant';
import { WikiService } from 'src/app/services/wiki.service';
import { ContentData } from '../../content-creator/add-content/models/content.model';

@Component({
    selector: 'app-create-game-map-view',
    templateUrl: './create-game-map-view.component.html',
    styleUrls: ['./create-game-map-view.component.scss'],
    standalone: false
})
export class CreateGameMapViewComponent
  implements OnInit, AfterViewInit, OnDestroy {
  map_id: any;
  @ViewChild('map', { read: ElementRef, static: true }) elementRef: ElementRef;
  pointSubscription: Subscription;
  startlocation: any;
  map_name: string;
  backRoute: string;
  showDropdown: boolean;
  newLayers: any[];

  objectData: any;
  sideInfoBar: boolean;
  layerlist: any = layerlist;
  city_id: string | number;
  cityMapVisibleSubscription: Subscription;
  isDisplayCityMap: boolean = false;
  cityBackRoute: string = '';
  cityMapCoordsSubscription: Subscription;
  cultureData: any;
  windowmapheight: number | string = '123px';
  isCityDetailsVisible: boolean = false;
  isCultureVisible: boolean = true;
  isMapDetailsVisible: boolean = false;
  cityData: any;
  legendData: any = [];
  currentLayerName: string = 'state';
  cellDetailsOrder: string[] = [
    'City Present',
    'Elevation',
    'Depth',
    'Population',
    'State',
    'Province',
    'Culture',
    'Religion',
    'Biome',
    'Land Area',
    'Geozone',
    'Natural Resources',
    'Bonus Resources',
    'Farm Resources',
    'Mineral Resources',
    'Special Resources',
  ];

  cityDetailsSortArray: string[] = [
    'City Name',
    'Population',
    'District',
    'Capitol',
    'Port',
    'Citadel',
    'City Walls',
    'Market Place',
    'Religious Center',
    'Shanty Town',
  ];
  contentCreatorData: any[] = [];
  playerCreatorData: any[] = [];
  coordsArrOfPointsUser: { coords: [number, number][]; idArr: number[]; content: ContentData[] };
  coordsArrOfPointsPlayer: any;
  userId: string | number;
  currentLayerWikiName: string = 'state';
  map_genre: string;

  constructor(
    private router: Router,
    private activtedroute: ActivatedRoute,
    private mapService: MapService,
    private coordinatesService: CoordinatesService,
    private modalService: NgbModal,
    private infoBarService: InfoBarMapViewService,
    private cityMapService: CityMapService,
    private dataService: DataService,
    private currentUserService: CurrentUserService,
    private wikiService: WikiService,
    private cdr: ChangeDetectorRef,
  ) { }
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    const headerHeight = 80; // Adjust according to your actual header height
    const footerHeight = 100; // Adjust according to your actual footer height
    const totalOffset = headerHeight + footerHeight;

    this.windowmapheight = window.innerHeight - totalOffset + 'px';
  }
  ngOnDestroy(): void {
    this.mapService?.removeOldMap();
    this.cityMapVisibleSubscription?.unsubscribe();
    this.cityMapCoordsSubscription?.unsubscribe();
    this.pointSubscription?.unsubscribe();
    this.mapService.unbindSingleClick();
  }
  ngAfterViewInit(): void {
    this.coordinatesService.setNewCoordinates(null);

    this.mapService.removeOldMap();
    this.resetLayers();
    this.activtedroute.params.subscribe((params) => {
      this.map_id = params['map_id']; // Accessing user_id parameter
      this.map_name = params['map_name'];
      this.map_genre = params['map_genre'];
      this.mapService.map_genre = this.map_genre;
      this.backRoute = params['backRoute'];
      this.getLegendDataLocal(this.map_id, this.currentLayerName);
      this.mapService.map.setTarget(this.elementRef.nativeElement);
      this.cityBackRoute =
        'creategame-mapview' +
        '/' +
        this.map_id +
        '/' +
        this.map_name +
        '/' +
        this.backRoute +
        '/' +
        this.map_genre;
      this.mapService.loadlayers({
        map_id: this.map_id,
        isFitExtent: true,
        type: 'Invitation',
        cityBackNavigate: this.cityBackRoute,
      });
      this.mapService.bindSingleClick();

      this.mapService.navigateToCityFlag = false;
      this.handleDrawingEnabled();
      this.intializeInformationSubscription();
      this.intializeCityMapSubscription();
      this.intializeCoordsSubscription();
      this.intializeUserSubscription();
    
          this.cdr.detectChanges();});
  }

  toggleCityMapDetails() {
    this.sideInfoBar = true;
    this.isCityDetailsVisible = !this.isCityDetailsVisible;
    return this.sideInfoBar;
  }

  private intializeCoordsSubscription() {
    this.pointSubscription = this.coordinatesService.pointDrawn$.subscribe(
      (coordinates) => {
        this.startlocation = coordinates;
        this.cdr.detectChanges();
      },
    );
  }

  private intializeUserSubscription() {
    this.currentUserService.currentUser.subscribe((user) => {
      if (user) {
        this.userId = user.id;
        setTimeout(() => {
          this.getAllRecords();
        }, 0);
      }
    
          this.cdr.detectChanges();});
  }

  getAllRecords() {
    forkJoin({
      contentCreator: this.dataService.getContentDataByMapId(
        this.userId,
        this.map_id,
      ),
      mapContentCreator: this.dataService.getContentDataOfPlayersByMapCode(
        this.map_id,
      ), // <-- your 2nd API here
    }).subscribe(
      (result: {
        contentCreator: { results: ContentData[] };
        mapContentCreator: { res: any[] };
      }) => {
        if (result.contentCreator) {
          this.contentCreatorData = result.contentCreator.results;
          this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
            this.contentCreatorData,
          );

          // Perform your action with the data
          this.mapService.addDifferentContentPin(
            true,
            this.coordsArrOfPointsUser,
            false,
          );

          // if (result.mapContentCreator.res) {
          //   // Do something with the second API result
          //   this.playerCreatorData = result.mapContentCreator.res;
          //   this.playerCreatorData = this.playerCreatorData.filter(
          //     (ele) => ele.user_id !== this.userId,
          //   );
          //   const rawCoords = this.playerCreatorData.map(
          //     (ele) => ele.coordslocationarr,
          //   );
          //   const parsedCoords = this.parseStringCoordinates(rawCoords);
          //   this.coordsArrOfPointsPlayer = {
          //     coords: parsedCoords,
          //     idArr: this.playerCreatorData.map((ele) => ele.id || 0),
          //   };
          //   this.mapService.addDifferentContentPin(
          //     false,
          //     this.coordsArrOfPointsPlayer,
          //     true,
          //     this.playerCreatorData,
          //   );
          // }
        }

        // Or combine both results in some logic
        // ...
      
          this.cdr.detectChanges();},
    );
  }

  private intializeInformationSubscription() {
    this.infoBarService.dataRetriver$.subscribe((data) => {
      if (!data) return;

      // According to the new InfoBarMapViewService, data = { resource_values, burg_values }
      const cell = data.resource_values;
      const burg = data.burg_values;
      if (!this.map_name && cell?.map_name) {
        this.map_name = cell.map_name;
      }

      // CELL DETAILS (right panel)
      this.objectData = {
        'City Present': burg ? 'Yes' : 'None',
        Culture: cell.culture,
        Religion: cell.religion,
        State: cell.state,
        Province: cell.province,
        Biome: cell.biome,
        Elevation: cell.elevation + ' ft' || 'NA',
        Depth: cell.depth + ' ft' || 'NA',
        Population: cell.population,
        'Natural Resources': cell.basic_resources,
        'Bonus Resources': cell.bonus_resources,
        'Mineral Resources': cell.mineral_resources,
        'Farm Resources': cell.farm_resources,
        'Special Resources': cell.special_resources,
      };
      if (this.objectData.Elevation === 'undefined ft' || this.objectData.Elevation === '0 ft') {
        delete this.objectData.Elevation;
      }
      if (this.objectData.Depth === 'undefined ft' || this.objectData.Depth === '0 ft') {
        delete this.objectData.Depth;
      }
      // CITY DETAILS (left panel)
      if (burg) {
        this.cityData = {
          'City Name': burg.burg || burg.Burg,
          Capitol: burg.capital || burg.Capital || 'No',
          Citadel: burg.citadel || burg.Citadel || 'No',
          Port: burg.port || burg.Port || 'No',
          'Market Place': burg.Plaza || 'No',
          'City Walls': burg.walls || burg.Walls || 'No',
          'Religious Center':
            burg.Temple && burg.Temple.length > 0 ? 'Yes' : 'No',
          'Shanty Town':
            burg['Shanty Town'] && burg['Shanty Town'].length > 0
              ? 'Yes'
              : 'No',
          Population: burg.population || burg.Population || cell.population,
        };
        this.isCityDetailsVisible = true;
        this.isMapDetailsVisible = true;
      } else {
        this.cityData = null;
        this.isCityDetailsVisible = false;
        this.isMapDetailsVisible = true;
      }
      this.cdr.detectChanges();
    });
  }

  cellDetailsSort = (a: any, b: any): number => {
    const order = this.cellDetailsOrder;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  cityDetailsSort = (a: any, b: any): number => {
    const order = this.cityDetailsSortArray;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  private intializeCityMapSubscription() {
    this.cityMapVisibleSubscription =
      this.cityMapService.cityMapVisible$.subscribe((value: any) => {
        if (value && value.visible === true) {
          this.isDisplayCityMap = value.visible;
          this.city_id = value.code;

          this.router.navigate(
            ['city-map-view/', value.code, this.map_id, 'null', 'null'],
            {
              queryParams: {
                token: '/assets/images/ac-token-game-large.png',
                isLoadToken: false,
                map_genre: this.map_genre,
                backRoute: this.cityBackRoute,
                map_name: this.map_name,
              },
            },
          );
        }
      
          this.cdr.detectChanges();});
  }

  resetLayers() {
    layerlist.forEach((layer) => {
      if (layer.name == 'state') {
        layer.checked = true;
      } else {
        layer.checked = false;
      }
    });
  }

  getLegendDataLocal(mapcode: string, layer_name: string) {
    this.dataService
      .getLegendData(mapcode, layer_name)
      .subscribe((data: { res: any[] }) => {
        if (data.res.length > 0) {
          this.legendData = data.res;
          this.processLegendData(this.legendData);
        } else {
          this.legendData = [];
        }
      
          this.cdr.detectChanges();});
  }

  processLegendData(legendData: any) {
    this.legendData = legendData.map((ele) => ({
      name: ele.name,
      full_name: ele.full_name,
      color: ele.color,
    }));
  }

  processCultureData(cultureData: any) {
    this.cultureData = cultureData.map((ele) => ({
      name: ele.name,
      color: ele.color,
    }));
  }

  handleDrawingEnabled() {
    const modalRef = this.modalService.open(CreateGameInfoModalComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.map_name = this.map_name;
    // modalRef.dismissed.subscribe((res) => {
    //   this.mapService?.addPointDrawInteraction(null, this.startlocation, null)

    // })
    modalRef.result.then((result) => {
      this.mapService?.addPointDrawInteraction(null, this.startlocation, null);
    
          this.cdr.detectChanges();});
  }

  filterlayers(layers) {
    this.newLayers = layers.filter((lyr) => lyr.toggle == true);
    return this.newLayers;
  }

  changeToggleLayer(item: any) {
    // each layer toggles independently, so a bare map plus any combination of
    // overlays can be shown at once, rather than exactly one at a time
    item.checked = !item.checked;
    const currentLayer = this.newLayers.find((lyr) => lyr.checked === true);
    if (currentLayer) {
      this.currentLayerName = currentLayer.name;
      this.currentLayerWikiName = currentLayer.label.toLowerCase();
      this.getLegendDataLocal(this.map_id, currentLayer.name);
    }
    this.mapService.filterAndToggleLayers(this.newLayers);
  }

  openGameCreateInvitationModal(event) {
    event.preventDefault();
    event.stopPropagation();

    const modalRef = this.modalService.open(
      CreateGameInvitationModalComponent,
      { size: 'lg', backdrop: 'static', centered: true },
    );
    modalRef.componentInstance.spawn_location = this.startlocation?.join(',');
    modalRef.componentInstance.map_id = this.map_id;
    modalRef.componentInstance.city_id = this.city_id;
    modalRef.componentInstance.map_genre = this.map_genre;
    modalRef.componentInstance.map_name = this.map_name;
    modalRef.result.then((result) => {
      if (result) {
        this.router.navigate(['/activegames']);
      }
    
          this.cdr.detectChanges();});
  }

  ngOnInit(): void {
    window.dispatchEvent(new Event('resize'));
  }

  openSideDropdownOption() {
    this.showDropdown = !this.showDropdown; // Toggles the dropdown visibility
  }

  selectOption(option: string) {
    // Logs the selected option
    this.showDropdown = false; // Closes the dropdown after selection
  }

  goBack(isBack?: boolean) {
    if (isBack) {
      this.router.navigate(['/activegames'], {
        queryParams: { tab: 'createModal' },
      });
    } else {
      this.router.navigate(['/activegames']);
    }
  }

  toggleCultureList() {
    this.isCultureVisible = !this.isCultureVisible;
  }

  toggleMapDetails() {
    this.sideInfoBar = true;
    this.isMapDetailsVisible = !this.isMapDetailsVisible;
    return this.sideInfoBar;
  }

  triggerZoomIn() {
    this.mapService.zoomIn();
  }

  triggerZoomOut() {
    this.mapService.zoomOut();
  }
  triggerTokenZoom() {
    this.mapService.zoomToExtent('creategame');
  }

  navigateToCityNameWiki() {
    this.wikiService.openCityWiki(
      this.cityData['City Name'],
      this.map_id,
      this.map_name,
    );
  }

  onDynamicDataClick(dataName: string) {
    this.wikiService.openWiki(
      this.currentLayerWikiName,
      dataName,
      this.map_id,
      this.map_name,
    );
  }

  navigateToWikiWorld(map_name?: string) {
    this.wikiService.openMapWiki(this.map_id, map_name || this.map_name);
  }

  hoveredResource: any = null;
  tooltipStyle: any = {};

  showResourceTooltip(event: MouseEvent, item: any): void {
    if (!item) return;
    this.hoveredResource = typeof item === 'string' ? { name: item } : item;
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const rect = target.getBoundingClientRect();
      const tooltipWidth = 330;
      const left = Math.max(10, rect.left - tooltipWidth - 15);
      const top = Math.max(10, Math.min(window.innerHeight - 240, rect.top - 20));
      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }

  hideResourceTooltip(): void {
    this.hoveredResource = null;
  }

  isResourceField(key: string | any): boolean {
    const resourceKeys = [
      'Natural Resources',
      'Bonus Resources',
      'Farm Resources',
      'Mineral Resources',
      'Special Resources',
    ];
    return resourceKeys.includes(key);
  }

  splitResources(value: string | any): any[] {
    if (!value || value === 'None') return [];
    if (Array.isArray(value)) {
      return value.map((item) => {
        if (typeof item === 'string') {
          return { name: item, description: '', production: 0, economy: 0, rarity: 0, processing: 0 };
        }
        return item;
      });
    }
    if (typeof value === 'string') {
      if (value.toLowerCase() === 'none') return [];
      return value.split(',').map((v) => ({
        name: v.trim(),
        description: '',
        production: 0,
        economy: 0,
        rarity: 0,
        processing: 0
      }));
    }
    return [];
  }

  onResourceClick(resource: string): void {
    this.wikiService.openResourceWiki(resource);
  }

  isLinkField(key: string | any): boolean {
    const linkKeys = ['State', 'Province', 'Culture', 'Religion', 'Biome'];
    return linkKeys.includes(key);
  }

  navigateToDynamicLink(key: string | any, value: string | any): void {
    this.wikiService.openWiki(key, value, this.map_id, this.map_name);
  }

  navigateToElevationLink() {
    const url = `${WORLD_TUMBLER_URL}/elevations/elevations`;
    window.open(url, '_blank');
  }

  private extractCoordinatesFromPins(contentData: ContentData[]): {
    coords: [number, number][];
    idArr: number[];
    content: ContentData[];
  } {
    const coords: [number, number][] = [];
    const idArr: number[] = [];
    const content: ContentData[] = [];
    (contentData || [])
      .filter((ele) => ele.pins && ele.pins.length > 0)
      .forEach((ele) => {
        ele.pins
          .filter(
            (pin) => String(pin.map_id) === String(this.map_id) && !pin.city_id,
          )
          .forEach((pin) => {
            coords.push([
              parseFloat(pin.latitude as any),
              parseFloat(pin.longitude as any),
            ]);
            idArr.push(pin.id);
            content.push(ele);
          });
      });
    return { coords, idArr, content };
  }

}
